<template>
  <div>
    <b-alert show v-if="ccrStatus && ccrStatus.status == 'rejected'" variant="danger" class="mt-3">
      <h4 class="alert-heading">Certification Status</h4>
      <p>
        The status of your CCR certification is: <strong>{{ formatCCRStatus(ccrStatus.status) }}</strong>
      </p>
      <p>Please submit a new certification using the form below.</p>
    </b-alert>
    <h3>CCR Certification</h3>
    <b-alert :show="!has_ccr" variant="warning" class="mt-3">
      <p>
        You must upload a CCR file before you can certify your CCR.
      </p>
      <b-button size="sm" class="ml-2" variant="primary" @click="changeTab(1)">
        Upload CCR File
      </b-button>
    </b-alert>
    <div v-if="ccrStatus && ccrStatus.status != 'rejected'">
      <b-alert show variant="info" class="mt-3">
        <h4 class="alert-heading">Certification Status</h4>
        <p>
          The status of your CCR certification is: <strong>{{ formatCCRStatus(ccrStatus.status) }}</strong>
        </p>
      </b-alert>
      <b-row v-if="receipt_uuid" class="mt-3">
        <b-col>
          <b-button class="mb-2 mr-2" variant="primary" @click="printReceipt">
            <b-icon icon="printer"></b-icon>
            Print Certification Receipt</b-button>
          <!--button link to open receipt in new window-->
          <b-button class="mb-2" variant="primary" :href="`/receipts/${receipt_uuid}`" target="_blank">
            <b-icon icon="box-arrow-up-right"></b-icon>
            Open in New Window
          </b-button>
          <iframe id="receiptFrame" :src="`/receipts/${receipt_uuid}`" width="100%" height="600"></iframe>
        </b-col>
      </b-row>
    </div>
    <div v-if="has_ccr && (!ccrStatus || ccrStatus.status == 'rejected')">
      <b-row>
        <b-col>
          <b-form-group label="PWS:" label-for="pws-input" label-cols="auto" class="mb-0">
            <b-form-input readonly :value="current_pws_label">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6">
          <b-form-group label="CCR YEAR:" label-cols="auto" class="mb-0">
            <b-form-input readonly v-model="ccrYear" type="number">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Population:" label-cols="auto" class="mb-0">
            <b-form-input v-model="population" type="number">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="mt-3" v-if="false">
        <h4>Distribution Methods</h4>
        <p>(Based on your population, determine the distribution method)</p>
        <ul>
          <li>
            <strong>Water systems serving 10,000 or more people must use:</strong>
            <ul>
              <li>Distribution Method I</li>
            </ul>
          </li>
          <li>
            <strong>Water systems serving 500 - 9,999 people must use:</strong>
            <ul>
              <li>Distribution Method I</li>
              <li>or Distribution Method II, III, and IV</li>
            </ul>
          </li>
          <li>
            <strong>Water systems serving less than 500 people must use:</strong>
            <ul>
              <li>Distribution Method I</li>
              <li>or Distribution Method II, III, and IV</li>
              <li>or Distribution Method III and IV</li>
            </ul>
          </li>
        </ul>
      </div>
      <hr />
      <h4>Distribution</h4> (Methods used to distribute CCR to our customers)
      <div id="delivery-methods" class="mt-3">
        <b-form-group>
          <b-form-checkbox v-model="mailCopy">
            Mailed paper copy
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="handDelivered">
            Hand delivered
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="emailedCopy">
            Emailed a Copy - CCR included as attachment or body of e-mail (not a link).
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="population < 10000">
          <label>Published Complete CCR in Newspaper(s) - Include names and dates of publication.</label>
          <b-form-input v-model="newspaper" placeholder="Enter names and dates of publication"></b-form-input>
        </b-form-group>
        <b-form-group label="Published at web address (URL):">
          <b-form-input v-model="webAddress" placeholder="Enter URL here"></b-form-input>
          <p class="text-muted">
            Example: https://www.waterworld.org/ccrMay2023/0830001.pdf
          </p>
        </b-form-group>
        <b-form-group v-if="webAddress" class="ml-3" label="Select a Web URL delivery methods:">
          <b-form-checkbox v-model="webAddressOnBill">
            Printed web URL above on bill.
          </b-form-checkbox>
          <b-form-checkbox v-model="webAddressMailed">
            Mailing included web URL above.
          </b-form-checkbox>
          <b-form-checkbox v-model="emailedWebAddress">
            Emailed with link to URL above.
          </b-form-checkbox>
        </b-form-group>
        <b-form-group id="copy-on-request" v-if="population < 500">
          <b-form-checkbox v-model="copyOnRequest">
            Notified customer that a copy is available on request.
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="copyOnRequest" class="ml-3">
          List all delivery methods used to notify customers that a copy is available on request.
          (e.g. insert, door hanger, postcard, newspaper, etc.)
          <b-form-input class="mt-2" v-model="copyOnRequestMethods">
          </b-form-input>
          <div v-if="copyOnRequestNewspaper" class="mt-2">
            <label>Name(s) of Papers and Date(s) of Publication</label>
            <b-form-input v-model="newspaper"></b-form-input>
          </div>
        </b-form-group>
        <b-form-group label="Other Delivery Methods or Details">
          <p>If the options above do not fully capture your delivery methods, please detail them here:</p>
          <b-form-input v-model="otherDelivery"></b-form-input>
        </b-form-group>
      </div>
      <!-- certification -->
      <b-form-group>
        <b-form-checkbox v-model="certify_form">
          I agree to the following statements:
        </b-form-checkbox>
      </b-form-group>
      <ul>
        <li>
          This Community public water system confirms it has distributed its Consumer Confidence Report (CCR) to its
          customers and to the MS State Department of Health, Bureau of Public Water Supply (MSDH/BPWS).
        </li>
        <li>
          The appropriate
          notices of availability have been given.
        </li>
        <li>
          The information contained in its CCR is correct and consistent with
          the compliance monitoring data previously analyzed and reported for this public water system including
          sample
          results from the MS Public Health Laboratory, MSDH/BPWS, and other outside or contract laboratories and
          the
          requirements of the CCR rule.
        </li>
        <li>
          Additionally, requirements for distribution vary by the size of the system and
          have been met. As required, we have made <strong>good faith efforts</strong> to reach customers who are
          served
          by the system
          but are not bill-paying customers, such as renters or workers. We have posted in public places such as
          libraries, cafeterias or lunchrooms, apartment buildings, or large private employers; or provided multiple
          copies to facilities for distribution.
        </li>
      </ul>
      <div class="text-right" v-if="!ccrStatus || ccrStatus.status == 'rejected'">
        <b-button :disabled="!enableSign" @click="showSignSend" class="mt-3" variant="primary">Submit
          Certification</b-button>
      </div>
      <SignAndSend :submit_title="`CCR Certification for ${pws_id}, ${pws_name}`" submit_url="ccr-certifications"
        :submit_data="submit_data" @signing-success="onSigningSuccess" />
    </div>
  </div>


</template>

<script>
import SignAndSend from "@/components/SignAndSend.vue"

export default {
  name: 'CCRCertification',
  components: {
    SignAndSend,
  },
  data() {
    return {
      has_ccr: false,
      // actually ccr cert status
      ccrStatus: null, // ccr cert status
      receipt_uuid: null,
      submit_data: {},
      certify_form: false,
      population: 0,
      mailCopy: false,
      handDelivered: false,
      webAddress: '',
      emailedCopy: false,
      emailedWebAddress: false,
      webAddressOnBill: false,
      webAddressMailed: false,
      copyOnRequest: false,
      copyOnRequestMethods: '',
      copyOnRequestInsert: false,
      copyOnRequestDoorHanger: false,
      copyOnRequestPostCard: false,
      copyOnRequestNewspaper: false,
      newspaper: '',
      newsPaperName: '',
      newsPaperDatePublishd: '',
      otherDelivery: '',
    };
  },
  methods: {
    // Add your component methods here
    //
    printReceipt() {
      const frame = document.getElementById('receiptFrame')
      // Wait for iframe to load fully
      if (frame.contentWindow.document.readyState === 'complete') {
        frame.contentWindow.print();
      } else {
        frame.onload = function () {
          frame.contentWindow.print();
        };
      }
    },
    async fetchPopulation() {
      // This method can be used to fetch or calculate the population
      const url = process.env.VUE_APP_API_URI + '/pws-info?pws_id=' + this.pws_id_signed_in
      try {
        const response = await this.axios.get(url)
        if (response.data && response.data.population) {
          this.population = response.data.population
        } else {
          console.error('Population data not found in the response')
        }
      } catch (error) {
        console.error('Error fetching population:', error)
      }
    },
    async fetchCCRCertificationStatus() {
      const url = process.env.VUE_APP_API_URI + `/ccr-certification-status?pws_id=${this.pws_id}&ccr_year=${this.ccrYear}`
      try {
        const response = await this.axios.get(url)
        console.log(response)
        if (response.data) {
          this.ccrStatus = response.data
          this.receipt_uuid = response.data.receipt_uuid
        } else {
          console.error('CCR status data not found in the response')
        }
      } catch (error) {
        console.error('Error fetching CCR status:', error)
      }
    },
    async fetchCCRStatus() {
      const url = process.env.VUE_APP_API_URI + '/ccr-status?pws_id=' + this.pws_id_signed_in
      try {
        const res = await this.axios.get(url)
        console.log(res)
        if (res.data && res.data.status_data) {
          // look for has_ccr
          for (const doc of res.data.status_data) {
            if (doc.has_ccr) {
              this.has_ccr = true
              console.log('Has CCR', this.has_ccr)
            }
          }
          
          // Check for ccr_url in the last record's file_properties
          const lastRecord = res.data.status_data[res.data.status_data.length - 1]
          if (lastRecord && lastRecord.file_properties) {
            try {
              const fileProps = JSON.parse(lastRecord.file_properties)
              if (fileProps.ccr_url && !this.webAddress) {
                this.webAddress = fileProps.ccr_url
              }
            } catch (parseError) {
              console.error('Error parsing file_properties:', parseError)
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    formatCCRStatus() {
      if (this.ccrStatus) {
        if (this.ccrStatus.status === 'pending') {
          return 'Pending Review'
        } else {
          return this.ccrStatus.status.charAt(0).toUpperCase() + this.ccrStatus.status.slice(1)
        }
      }
      return ''
    },
    changeTab(tabIndex) {
      console.log('changeTab', tabIndex)
      this.$emit('changeTab', tabIndex)
    },
    showSignSend() {
      this.submit_data.ccr_year = this.ccrYear
      this.submit_data.pws_id = this.$store.state.pws.pws_id
      this.submit_data.pws_name = this.$store.state.pws.pws_name
      this.submit_data.population = this.population
      this.submit_data.mail_copy = this.mailCopy
      this.submit_data.hand_delivered = this.handDelivered
      this.submit_data.emailed_copy = this.emailedCopy
      this.submit_data.web_address = this.webAddress
      this.submit_data.emailed_web_address = this.emailedWebAddress
      this.submit_data.web_address_on_bill = this.webAddressOnBill
      this.submit_data.web_address_mailed = this.webAddressMailed
      this.submit_data.newspaper = this.newspaper
      this.submit_data.copy_on_request = this.copyOnRequest
      this.submit_data.copy_on_request_methods = this.copyOnRequestMethods
      this.submit_data.other_delivery = this.otherDelivery
      this.submit_data.certify_form = this.certify_form
      this.$bvModal.show('sign-send')
    },
    onSigningSuccess(data) {
      // confirmation_id is the receipt ID
      console.log('onSigningSuccess', data)
      this.fetchCCRCertificationStatus()
      //this.$bvModal.hide('sign-send')
      //this.$router.push({ name: 'MonitoringWaiverStatus' })
    },

  },
  watch: {
    // watch population to determine which distribution methods are available
    //population(newValue) {
    //  console.log('Population is ' + newValue)
    //  if (newValue < 500) {
    //    document.getElementById('copy-on-request').style.display = 'block';
    //  }
    //  else if (newValue > 500) {
    //    // copy on request is not available
    //    document.getElementById('copy-on-request').style.display = 'none';
    //  }
    //},
    webAddress(newValue) {
      if (!newValue) {
        // related fields reset
        this.webAddressOnBill = false;
        this.webAddressMailed = false;
        this.emailedWebAddress = false;
      }
    },
    copyOnRequest(newValue) {
      // handle the copy on request checkbox
      if (!newValue) {
        // clear related fields if unchecked
        this.copyOnRequestInsert = false;
        this.copyOnRequestDoorHanger = false;
        this.copyOnRequestPostCard = false;
        this.copyOnRequestNewspaper = false;
      }
    },
  },
  computed: {
    ccrYear() {
      // previous year
      return new Date().getFullYear() - 1

    },
    pws_id() {
      return this.$store.state.pws.pws_id
    },
    pws_name() {
      return this.$store.state.pws.pws_name
    },
    pws_id_signed_in() {
      return this.$store.state.pws_id
    },
    current_pws() {
      return this.$store.state.pws
    },
    current_pws_label() {
      return `${this.current_pws.pws_name} (${this.current_pws.pws_id})`
    },
    urlMethodSelected() {
      return this.webAddress && (this.webAddressOnBill || this.webAddressMailed || this.emailedWebAddress)
    },
    enableSign() {
      return this.certify_form && (this.mailCopy || this.handDelivered || this.emailedCopy || this.urlMethodSelected || this.copyOnRequest || this.newspaper || this.otherDelivery)
    }
  },
  mounted() {
    // Initialize the population value if needed
    this.population = 0; // or set it to a default value
    this.fetchPopulation()
    this.fetchCCRStatus()
    this.fetchCCRCertificationStatus()
  },
};
</script>
